import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "file-picture",
  "use": "file-picture-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"file-picture\"><path d=\"M416 448H96v-64l96-160 131.5 160 92.5-64v128zM416 240c0 26.51-21.49 48-48 48-26.511 0-48-21.49-48-48s21.489-48 48-48c26.51 0 48 21.49 48 48z\" /><path d=\"M458.903 114.538c-11.106-15.146-26.587-32.85-43.589-49.852s-34.706-32.482-49.852-43.589C339.675 2.187 327.166 0 320 0H72C49.944 0 32 17.944 32 40v432c0 22.056 17.944 40 40 40h368c22.056 0 40-17.944 40-40V160c0-7.166-2.186-19.675-21.097-45.462zm-66.216-27.225c15.35 15.35 27.4 29.199 36.29 40.687H352V51.027c11.492 8.89 25.339 20.939 40.687 36.286zM448 472c0 4.336-3.664 8-8 8H72c-4.336 0-8-3.664-8-8V40c0-4.336 3.664-8 8-8h248v112c0 8.836 7.163 16 16 16h112v312z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/file-picture.svg
// module id = QEeu
// module chunks = 1